export default{
  notifications: state => state.notifications,
  newNotificationCount: state => state.newNotificationCount

}